import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[validTelephone]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: ValidTelephoneValidatorDirective,
        multi: true
    }]
})
export class ValidTelephoneValidatorDirective implements Validator {
    @Input() field: string;

    validate(control: AbstractControl): {[key: string]: any} {
        let value = control.value;
        if (!value) {
            return null;
        }

        value = value.replace(/\D/g, '');
        if (value.length < 10 || value.length > 11) {
            return {'telephone-length': true};
        }

        return null;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/shared/validators/valid-telephone.directive.ts